import { Component, OnInit, Input } from '@angular/core';
import { FormGroup ,FormControl, Validators } from "@angular/forms";
import { CursoService } from "../../servicios/curso.service";
import { cursoI } from 'src/app/shared/models/curso.interface';


@Component({
  selector: 'app-editar-curso',
  templateUrl: './editar-curso.component.html',
  styleUrls: ['./editar-curso.component.scss']
})
export class EditarCursoComponent implements OnInit {

  private image:any;
  private imageOriginal:any;
  
  @Input() curso:cursoI;

  public editCursoForm = new FormGroup({
    id: new FormControl("", Validators.required),
    titulo: new FormControl("", Validators.required),
    content: new FormControl("", Validators.required),
    tags: new FormControl("", Validators.required),
    imagen: new FormControl("", Validators.required),
    creador: new FormControl("", Validators.required),
  })

  constructor(private cursoSvc:CursoService) { }

  ngOnInit(): void {

    this.image = this.curso.imagen;
    this.imageOriginal = this.curso.imagen;
    this.initValForm();

  }

  editCurso(curso:cursoI)
  {
    curso.videos = [];
    
    if(this.image == this.imageOriginal)
    {
      curso.imagen = this.imageOriginal;
      //llamo al metodo(curso)
      this.cursoSvc.editCursoById(curso);
    }
    else
    {
      //llamo al metodo(curso, imagen)
      this.cursoSvc.editCursoById(curso, this.image)
    }
    
  }

  handleArchivo(event:any)
  {
    this.image = event.target.files[0];

  }

  private initValForm()
  {
    this.editCursoForm.patchValue({
      id:this.curso.id,
      titulo: this.curso.titulo,
      content:this.curso.content,
      tags:this.curso.tags,
      creador:this.curso.creador

    })
  }

}
